import AfterDoc from '@/components/ui/AfterDoc';
import { CONSULTANTS } from '@/features/v2/consultants';

import { useLingui } from '@lingui/react';

const ThankYouNoQualifyUnder10K = () => {
  const { i18n } = useLingui();

  return (
    <AfterDoc
      consultant={CONSULTANTS.EWELINA_ASSISTANT}
      thankYouMessage={i18n.t(
        'Niestety nie możemy zaoferować obsługi Twojej sprawy'
      )}
      withButton
    >
      <>
        <span>
          {i18n.t(
            'W przypadku pojazdów przed szkodą wycenianych poniżej 10 000 PLN, nasze możliwości działania są ograniczone.'
          )}
        </span>
        <span className="font-semibold">
          {i18n.t('W przypadku dodatkowych pytań zapraszamy do kontaktu.')}
        </span>
      </>
    </AfterDoc>
  );
};

export default ThankYouNoQualifyUnder10K;
